module.exports = __webpack_public_path__ + "static/media/audioAdjustment.e6d4a0c0.mp3";